import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {TEMPLATE} from '../../service/template/types';
import {selectPresentationToEditAction} from '../../store/actions/presentation';
import {selectedPresentationSelector} from '../../store/selectors/presentation.selectors';
import {clearHistoryState} from '../../utils/history';

function useSelectPresToEdit(presId?: string): void {
    const dispatch = useDispatch();
    const {state} = useLocation();

    const selectedPresentation = useSelector(selectedPresentationSelector);
    const {_id, found} = selectedPresentation;

    const navigate = useNavigate();

    useEffect(() => {
        const isPresSelected = _id === presId;

        if (found === false) navigate('/');
        else if (!isPresSelected) {
            dispatch(selectPresentationToEditAction(presId || '', navigate, state?.template as TEMPLATE));
            clearHistoryState();
        }
    }, [_id, dispatch, found, navigate, presId, state?.template]);
}

export default useSelectPresToEdit;
